import React from "react";
import Pagination from "rc-pagination";
import {locale} from "../../common/table/paginatorConfig";
import { SortIcons } from "components/SortIcons/SortIcons";
import { IPageResponse, SortDirection } from "common/interfaces/IPageResponse";
import { Partner, PartnerSortFields } from "./models";
import { dateFormatOptions } from "common/dateFormatterConfig";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { ModalType } from "common/common-models";

interface PartnersTableProps {
  partners?: IPageResponse<Partner>;
  onPageChange: (page: number, size: number) => void;
  onSort: (sortField: PartnerSortFields) => void;
  sortField: PartnerSortFields;
  sortDirection: SortDirection;
  isRequesting: boolean;
  openEditPartnerModal: (modalType: ModalType, partner: Partner) => void;
  openDeletePartnerModal: (partner: Partner) => void;
}

export function PartnersTable(props: PartnersTableProps) {
    const partners: Array<Partner> = props.partners ? props.partners.content : [];
    const pageResponse = props.partners;

    const partnerTableRows = partners.map((partner) =>
        <tr key={'row-' + partner.id}>
            <td className="text-nowrap">
                {partner.id}<br />
            </td>
            <td className="line-height-1">
                {partner.name}<br />
            </td>
            <td className="text-nowrap">
                {partner.contactEmail}
            </td>
            <td className="text-nowrap">
                {partner.cardNumberMaskLength}
            </td>
            <td className="text-nowrap">
                {partner.hourlyRequestLimit}
            </td>
            <td className="text-nowrap">
                {partner.dailyRequestLimit}
            </td>
            <td className="text-nowrap">
                {partner.isActive ? 'Jah' : 'Ei'}
            </td>
            <td className="text-nowrap">
                {partner.dateCreated ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(partner.dateCreated)) : ""}
            </td>
            <td>
                <div className="row__actions">
                    <OverlayTrigger
                        delay={250}
                        overlay={
                            <Tooltip id={`tooltip-edit-${partner.id}`}>
                                <p style={{margin: '3px'}}>Muuda</p>
                            </Tooltip>
                        }
                        placement={"left"}
                    >
                        <Button
                            size="sm"
                            variant="outline-dark"
                            className="d-flex align-items-center border-color-background border-radius-circle btn-outline-icon"
                            onClick={() => {
                                props.openEditPartnerModal(ModalType.EDIT, partner);
                            }}
                        >
                            <i className="icon--16 my-2 icon__edit--outline-mask"/>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        delay={250}
                        overlay={
                            <Tooltip id={`tooltip-delete-${partner.id}`}>
                                <p style={{margin: '3px'}}>Kustuta</p>
                            </Tooltip>
                        }
                        placement={"left"}
                    >
                        <Button size="sm" variant="outline-danger"
                                className="d-flex align-items-center border-color-background border-radius-circle btn-outline-icon"
                                onClick={() => {
                                    props.openDeletePartnerModal(partner);
                                }}>
                            <i className="icon--16 my-2 icon__delete--outline-mask"/>
                        </Button>
                    </OverlayTrigger>
                </div>
            </td>
        </tr>
    );

    return (
        <table className='generic-table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(PartnerSortFields.ID)}>
                        <span>ID</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={PartnerSortFields.ID} />
                    </div>
                </th>
                <th className="sort-down-up-hover">
                    <div className="d-flex align-items-center"
                        onClick={() => props.onSort(PartnerSortFields.NAME)}>
                        <span>Nimi</span>
                        <SortIcons
                            sortedByField={props.sortField}
                            sortDirection={props.sortDirection}
                            currentSortColumn={PartnerSortFields.NAME} />
                    </div>
                </th>
                <th>Kontakti e-mail</th>
                <th>Kaardinumbri maski pikkus</th>
                <th>Limiit/tund</th>
                <th>Limiit/päev</th>
                <th>Aktiivne</th>
                <th>Loodud</th>
                <th>Tegevused</th>
            </tr>
            </thead>
            <tbody>
                {
                    props.isRequesting ?
                    <tr>
                        <td colSpan={10} className="spinner-cell">
                            <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="grow" />
                            </div>
                        </td>
                    </tr> : partnerTableRows
                }
            </tbody>
            {
                pageResponse ? (
                    <tfoot>
                        <tr>
                            <td colSpan={9}>
                                <div className="pagination-wrapper">
                                    <Pagination
                                        locale={locale}
                                        current={pageResponse.number + 1}
                                        total={pageResponse.totalElements}
                                        pageSize={pageResponse.size}
                                        prefixCls={"pagination"}
                                        onChange={props.onPageChange}
                                        showSizeChanger={false}
                                        hideOnSinglePage={true}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                ) : null
            }
        </table>
    )
}
